import React from 'react';
import { Box, Typography } from '@mui/material';
import RichEditor from './RichEditor';
import '../../styles/lms-courses.css';

/**
 * RichEditor для курсів/матеріалів LMS.
 * AI → /api/lms/ai/rewrite/; upload → /api/lms/upload/.
 */
export default function LmsRichEditor({ value = '', onChange, label, minHeight }) {
  return (
    <Box className="lms-rich-root">
      {label ? (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
          {label}
        </Typography>
      ) : null}
      <Box
        sx={
          minHeight
            ? {
                '& .richedit': { minHeight: `${minHeight}px` },
              }
            : undefined
        }
      >
        <RichEditor value={value || ''} onChange={onChange} />
      </Box>
    </Box>
  );
}
